import axios from "axios";
import * as Sentry from "@sentry/vue";
import { ResponseExceptions } from "@/store/types/types";
import { IRequestFail } from "./api-types";

const ErrorDefault = (response: ResponseExceptions) => {
  Sentry.captureException(response, function(scope) {
    scope.setTransactionName(`${response.config.url}`);
    return scope;
  });
};

export const ApiException = (response: ResponseExceptions) => {
  if (!response?.status) {
    return {
      kind: "Unknown",
      message: "Ocorreu um erro inesperado, tente novamente."
    };
  }

  const isArray = Array.isArray(response?.data);

  const getMessage = () => {
    if (isArray) {
      const error = response.data.find((error: IRequestFail) => error.message);
      return error?.message;
    }
    return response.data.message;
  };

  switch (response.status) {
    case 400:
      ErrorDefault(response);
      return {
        kind: "Bad Request",
        data: response?.data,
        message: getMessage(),
        action: isArray ? response.data[0].action : response.data.action
      };
    case 401:
      return {
        kind: "Unauthorized",
        message: getMessage()
      };
    case 403:
      return {
        kind: "Forbidden",
        data: response?.data,
        message:
          !isArray && response.data.message
            ? response.data.message
            : "Este usuário não pode acessar esse conteúdo!"
      };
    case 404:
      ErrorDefault(response);
      return {
        kind: "Not Found",
        message:
          !isArray && response.data.message ? response.data.message : null
      };
    case 500:
      return {
        kind: "Server Error",
        message: "Ocorreu um erro inesperado, tente novamente."
      };
    default:
      ErrorDefault(response);
      return {
        kind: "Unknown",
        message: "Ocorreu um erro inesperado, tente novamente."
      };
  }
};

export const ApiInterception = (code = 0, action = (error: any) => error) =>
  axios.interceptors.response.use(
    response => response,
    error => {
      if (
        error.request.status === code &&
        error.config &&
        !error.config.__isRetryRequest
      )
        action(error);

      throw error;
    }
  );
